import { useQuery } from 'react-query';
import request from '../helpers/request';
import { phoneQueryKeys } from '../containers/Phone/queries/queryKeys';

export const getPhoneSettings = async () => {
  return await request.get(
    `/Phone/settings`,
    {},
    'При загрузке настроек для звонков произошла ошибка',
  );
};

const usePhoneSettings = (options) =>
  useQuery(phoneQueryKeys.phoneSettings(), getPhoneSettings, options);

export default usePhoneSettings;
